module.exports = __webpack_public_path__ + "img/新增项目icon@2x.643bb824.png";